module.exports = __webpack_public_path__ + "88d1d779101ce7dfcb8c89c4b36d3fcb.svg";